export const FinanceData = {
    "Lenders":[
    {
        "Climate First Bank":
            [
                {
                    "product": "Climate First 30 Year 8% APR",
                    "term": 30.5,
                    "apr": 8,
                    "fee": 0,
                    "type": "Loan"
                },

            ]
    },
    {
        // The lender behind the Participate promotions. Quoted as a payment
        // factor rather than an APR: the monthly payment is the financed amount
        // multiplied by `factor`, with no amortisation schedule behind it. A
        // customer only keeps the 25% or 30% off if they finance here — or pay
        // cash. See PARTICIPATE_LENDER in Promotions.js.
        "Credit Human":
            [
                {
                    "product": "Credit Human 25 Year",
                    "term": 25,
                    "apr": 0,
                    "fee": 0,
                    "factor": 0.0095,
                    "type": "Loan"
                },
            ]
    },
    // {
    //     "Goodleap": 
    //         [
    //             {
    //                 "product": "Goodleap 25 Year 10.99% APR 7.74% Fee",
    //                 "term": 25,
    //                 "apr": 10.99,
    //                 "fee": 7.74,
    //                 "type": "Loan"
    //             },
    //         ]
    // },
    // {
    //     "Lightreach": 
    //         [
    //             {
    //                 "product": "Lightreach 25 Year Lease 0% Fee",
    //                 "term": 25,
    //                 "apr": 0,
    //                 "fee": 0,
    //                 "type": "Lease"
    //             },
    //         ]
    // },
    // {
    //     "Dividend": 
    //         [
    //             {
    //                 "product": "Dividend 25 Year 32.4% Fee",
    //                 "term": 25,
    //                 "apr": 0,
    //                 "fee": 32.4,
    //                 "type": "Loan"
    //             },
    //             {
    //                 "product": "Dividend 15 Year 8.99% APR",
    //                 "term": 15,
    //                 "apr": 8.99,
    //                 "fee": 0,
    //                 "type": "Loan"
    //             },
    //         ]
    // },
]}